import { axios, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

type Payload = {
  userData: Record<string, unknown>;
};

export const authSignUp = createApiSlice<unknown, Payload>({
  name: 'authSignUp',
  *tryGenerator(_, { payload: { userData } }) {
    yield call(axios, {
      method: 'post',
      url: getEndpointV2({ path: '/auth/register' }),
      data: userData,
    });

    return null;
  },
});
